export enum TypeCamera{
    FrontCam,
    TopCam
}